import { Alert, Button, Divider, List, ListItem, listItemClasses, ListItemText, Stack, Switch } from '@mui/material';
import { FC } from 'react';
import Modal from '@/ui/Modal';
import { FeatureFlagNames } from './feature-flag';
import { useFeatureFlagIsEntryVisible } from './hooks/useFeatureFlagIsEntryVisible';
import { useFeatureFlags } from './hooks/useFeatureFlags';

interface FeatureFlagPopupProps {
  onClose?: () => void;
}

export const FeatureFlagPopup: FC<FeatureFlagPopupProps> = ({ onClose }) => {
  const [isFeatureFlagEntryVisible, setIsFeatureFlagEntryVisible] = useFeatureFlagIsEntryVisible();
  const [featureFlags, setFeatureFlag] = useFeatureFlags();

  return (
    <Modal open title="Feature Flags" onCancel={onClose}>
      <Modal.Content>
        <Stack>
          {FeatureFlagNames.length ? (
            <List
              disablePadding
              sx={{
                [`& .${listItemClasses.root}:last-child`]: {
                  borderBottom: 0,
                },
              }}
            >
              {FeatureFlagNames.map((flag) => (
                <ListItem key={flag} disableGutters divider>
                  <ListItemText id={`feature-flag-switch-label-${flag}`} primary={flag} />
                  <Switch
                    edge="end"
                    checked={featureFlags[flag]}
                    onChange={(_, checked) => setFeatureFlag(flag, checked)}
                    slotProps={{
                      input: { 'aria-labelledby': `feature-flag-switch-label-${flag}` },
                    }}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Alert severity="info">No Feature Flags Available</Alert>
          )}
        </Stack>

        <Stack sx={{ mt: 3 }}>
          <Divider />
          <ListItem component="div" disableGutters>
            <ListItemText id="feature-flags-entry-switch-label" primary="Toggle Feature Flags Entry" />
            <Switch
              edge="end"
              checked={isFeatureFlagEntryVisible}
              onChange={() => setIsFeatureFlagEntryVisible(!isFeatureFlagEntryVisible)}
              slotProps={{
                input: { 'aria-labelledby': 'feature-flags-entry-switch-label' },
              }}
            />
          </ListItem>
        </Stack>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Close</Button>
      </Modal.Actions>
    </Modal>
  );
};
